import Reflux from "reflux";
export default Reflux.createActions(["OpenSubcategory", "CloseMobileMenu", "ChangeState", "OpenSubTree"]);
